(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ggx-floor-magic"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'ggx-floor-magic';
  if (!window.customElements || customElements.get(tag)) return;
  class FloorMagic extends HTMLElement {
    connectedCallback() {
      if (this.abort || !window.IntersectionObserver) return;
      this.stage = this.closest('.ggx-threshold');
      this.svg = this.querySelector('svg');
      this.scene = this.closest('ggx-portal-scene');
      if (!this.stage || !this.svg) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.fine = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.contrast = matchMedia('(forced-colors: active)');
      this.level = 0;
      this.inside = false;
      this.inView = false;
      this.pageActive = true;
      this.paused = false;
      this.localPaused = false;
      try { this.paused = ['true', '1'].includes(sessionStorage.getItem('ggx-living-motion-paused')); } catch { }
      this.reset();
      this.stage.addEventListener('pointermove', (event) => {
        if (!this.allowed() || (event.pointerType !== 'mouse' && event.pointerType !== 'pen')) return;
        const matrix = this.svg.getScreenCTM();
        if (!matrix) return;
        const point = new DOMPoint(event.clientX, event.clientY).matrixTransform(matrix.inverse());
        this.setInside(((point.x - 815) / 325) ** 2 + ((point.y - 705) / 50) ** 2 <= 1);
      }, { ...options, passive: true });
      this.stage.addEventListener('pointerleave', () => this.setInside(false), options);
      this.stage.addEventListener('pointercancel', () => this.setInside(false), options);
      window.addEventListener('gg:discovery-floor-start', (event) => {
        if (event.detail?.room !== this.stage || !this.allowed()) return;
        clearTimeout(this.audioFadeTimer);
        this.audioHeld = true;
        this.audioFading = false;
        this.dataset.floorAudioHeld = 'true';
        if (this.dataset.floorState !== 'bloom' && this.dataset.floorState !== 'hold') this.animate('bloom');
      }, options);
      window.addEventListener('gg:discovery-floor-progress', (event) => {
        if (event.detail?.room !== this.stage || !this.audioHeld || !this.allowed()) return;
        const level = Math.max(0, Math.min(1, Number(event.detail.level)));
        if (!Number.isFinite(level) || level >= 1) return;
        this.audioFading = true;
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.level = .85 * level;
        this.style.opacity = this.level.toFixed(4);
        this.dataset.floorState = 'fade';
      }, options);
      window.addEventListener('gg:discovery-floor-end', (event) => {
        if (event.detail?.room !== this.stage || !this.audioHeld) return;
        clearTimeout(this.audioFadeTimer);
        this.audioHeld = false;
        this.dataset.floorAudioHeld = 'false';
        if (this.audioFading) { cancelAnimationFrame(this.frame); this.level = 0; this.style.opacity = '0'; this.dataset.floorState = 'idle'; this.audioFading = false; }
        else if (this.allowed()) this.animate('fade');
        else this.reset();
      }, options);
      const refresh = () => { if (!this.allowed()) this.reset(); };
      for (const media of [this.fine, this.reduced, this.contrast]) media.addEventListener('change', refresh, options);
      document.addEventListener('visibilitychange', refresh, options);
      window.addEventListener('pagehide', () => { this.pageActive = false; this.reset(); }, options);
      window.addEventListener('pageshow', () => { this.pageActive = true; refresh(); }, options);
      const preference = (event) => {
        if (typeof event.detail?.paused !== 'boolean') return;
        this.paused = event.detail.paused;
        refresh();
      };
      window.addEventListener('ggx:motion-preference', preference, options);
      document.addEventListener('ggx:motion-preference', preference, options);
      this.scene?.querySelector('[data-portal-choice="still"]')?.addEventListener('click', () => { this.localPaused = true; this.reset(); }, options);
      this.scene?.querySelector('[data-portal-choice="motion"]')?.addEventListener('click', () => { this.localPaused = false; }, options);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries.some(entry => entry.isIntersecting);
        refresh();
      }, { threshold: 0 });
      this.observer.observe(this.stage);
    }
    allowed() {
      return Boolean(this.abort && this.isConnected && this.fine.matches && !this.reduced.matches && !this.contrast.matches && !this.paused && !this.localPaused && this.inView && this.pageActive && !document.hidden);
    }
    reset() {
      clearTimeout(this.audioFadeTimer);
      this.audioFading = false;
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.level = 0;
      this.inside = false;
      this.audioHeld = false;
      this.dataset.floorAudioHeld = 'false';
      this.style.opacity = '0';
      this.dataset.floorState = 'idle';
      this.dataset.floorInside = 'false';
    }
    setInside(inside) {
      if (inside === this.inside) return;
      this.inside = inside;
      this.dataset.floorInside = String(inside);
      if (!this.allowed()) { this.reset(); return; }
      if (inside) window.dispatchEvent(new CustomEvent('gg:discovery-floor', {detail:{room:this.stage}}));
      if (inside && !this.audioFading && this.dataset.floorState !== 'bloom' && this.dataset.floorState !== 'hold') this.animate('bloom');
      else if (!inside && !this.audioHeld && this.dataset.floorState === 'hold') this.animate('fade');
    }
    animate(phase, durationOverride) {
      cancelAnimationFrame(this.frame);
      this.dataset.floorState = phase;
      const start = this.level;
      const target = phase === 'bloom' ? .85 : 0;
      const duration = durationOverride || (phase === 'bloom' ? 1800 : 2600);
      const started = performance.now();
      const tick = (time) => {
        this.frame = 0;
        if (!this.allowed()) { this.reset(); return; }
        const progress = Math.min(1, Math.max(0, (time - started) / duration));
        const eased = progress * progress * (3 - 2 * progress);
        this.level = start + (target - start) * eased;
        this.style.opacity = this.level.toFixed(4);
        if (progress < 1) this.frame = requestAnimationFrame(tick);
        else if (phase === 'bloom' && !this.inside && !this.audioHeld) this.animate('fade');
        else this.dataset.floorState = phase === 'bloom' ? 'hold' : 'idle';
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      this.reset();
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
    }
  }
  customElements.define(tag, FloorMagic);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ggx-mobile-entrance"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'ggx-mobile-world-reveals';
  if (!window.customElements || customElements.get(tag)) return;
  class MobileWorldReveals extends HTMLElement {
    connectedCallback() {
      if (this.abort || typeof IntersectionObserver !== 'function' || !Element.prototype.animate) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.contrast = matchMedia('(forced-colors: active)');
      this.seen ||= new WeakSet();
      this.animations = new Set();
      this.layers = new Set();
      this.generation = 0;
      this.paused = false;
      this.readPreference();
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          // Wait for most of the scene, or most of the usable viewport for tall images.
          const available = entry.rootBounds?.height || Math.max(1, innerHeight - 128);
          const required = Math.min(entry.boundingClientRect.height, available) * .78;
          if (!entry.isIntersecting || entry.intersectionRect.height < required || !this.mobile.matches) continue;
          const scene = entry.target;
          this.observer.unobserve(scene);
          if (this.seen.has(scene)) continue;
          this.seen.add(scene);
          this.reveal(scene);
        }
      }, { threshold: Array.from({ length: 41 }, (_, i) => i / 40), rootMargin: '-64px 0px -64px 0px' });
      this.querySelectorAll('.ggx-mobile-scene').forEach(scene => { if (!this.seen.has(scene)) this.observer.observe(scene); });
      const cancel = () => { if (!this.allowed()) this.stop(); };
      for (const media of [this.mobile, this.reduced, this.contrast]) media.addEventListener('change', cancel, options);
      document.addEventListener('visibilitychange', cancel, options);
      window.addEventListener('pagehide', () => this.stop(), options);
      window.addEventListener('pageshow', () => { this.readPreference(); cancel(); }, options);
      const preference = event => {
        if (typeof event.detail?.paused !== 'boolean') return;
        this.paused = event.detail.paused;
        cancel();
      };
      window.addEventListener('ggx:motion-preference', preference, options);
      document.addEventListener('ggx:motion-preference', preference, options);
      window.addEventListener('storage', event => {
        if (event.key === 'ggx-living-motion-paused' || event.key === null) { this.readPreference(); cancel(); }
      }, options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('pointerdown', () => this.stop(), { ...options, passive: true });
    }
    readPreference() {
      try { const value = sessionStorage.getItem('ggx-living-motion-paused'); this.paused = value === 'true' || value === '1'; } catch { }
    }
    allowed() {
      return this.isConnected && this.mobile.matches && !this.reduced.matches && !this.contrast.matches && !this.paused && !document.hidden;
    }
    async reveal(scene) {
      if (!this.allowed() || scene.contains(document.activeElement)) return;
      const media = scene.querySelector('.ggx-mobile-scene-media');
      const image = media?.querySelector('img');
      if (!image) return;
      const generation = this.generation;
      try { if (image.decode) await image.decode(); } catch { return; }
      const bounds = scene.getBoundingClientRect();
      if (generation !== this.generation || !this.allowed() || !image.naturalWidth || bounds.bottom <= 0 || bounds.top >= innerHeight) return;
      // Base art is never hidden. Only temporary decorative planes materialize.
      this.play(image, [{ transform: 'scale(1)' }, { transform: 'scale(1.05)' }], 2800);
      const kind = scene.dataset.reveal;
      this.sparkles(media, kind);
      if (kind === 'mist') {
        this.plane(media, 'mist-left', [{ opacity: .72, transform: 'translateX(0) scale(1)' }, { opacity: 0, transform: 'translateX(-42%) scale(1.12)' }], 2300);
        this.plane(media, 'mist-right', [{ opacity: .62, transform: 'translateX(0) scale(1)' }, { opacity: 0, transform: 'translateX(44%) scale(1.1)' }], 2500, 70);
      } else if (kind === 'dawn') {
        this.plane(media, 'dawn-veil', [{ opacity: .82, transform: 'translateX(-8%)' }, { opacity: 0, transform: 'translateX(105%)' }], 2400);
        this.plane(media, 'dawn-light', [{ opacity: 0, transform: 'translateX(-85%)' }, { opacity: .46, offset: .42 }, { opacity: 0, transform: 'translateX(105%)' }], 2600);
      } else if (kind === 'portal') {
        this.plane(media, 'portal', [{ opacity: 1, transform: 'scale(.72)' }, { opacity: .88, offset: .38 }, { opacity: 0, transform: 'scale(2.25)' }], 2600);
        this.plane(media, 'portal-rim', [{ opacity: .2, transform: 'scale(.9)' }, { opacity: .38, offset: .35 }, { opacity: 0, transform: 'scale(2)' }], 2400);
      } else if (kind === 'spectral') {
        if (window.CSS?.supports('mask-image', 'radial-gradient(transparent, black)')) {
          const ghost = image.cloneNode(false);
          ghost.removeAttribute('id'); ghost.removeAttribute('srcset'); ghost.removeAttribute('sizes');
          ghost.src = image.currentSrc || image.src;
          ghost.alt = ''; ghost.loading = 'eager'; ghost.setAttribute('aria-hidden', 'true');
          ghost.className = 'ggx-magic-plane ggx-magic-ghost';
          ghost.style.objectPosition = getComputedStyle(image).objectPosition;
          media.append(ghost); this.layers.add(ghost);
          this.play(ghost, [{ opacity: .52, transform: 'translateX(-3%) scale(1.2)' }, { opacity: .34, offset: .45 }, { opacity: 0, transform: 'translateX(0) scale(1.05)' }], 2500, 0, ghost);
        }
        this.plane(media, 'spectral-glow', [{ opacity: .28, transform: 'scale(.8)' }, { opacity: .1, offset: .45 }, { opacity: 0, transform: 'scale(1.16)' }], 2300);
      }
    }
    sparkles(media, kind) {
      // Ten small, single-peaked accents only; no loops or full-frame flashes.
      const points = [[18,26],[34,18],[63,22],[81,34],[25,47],[72,52],[45,35],[56,57],[12,61],[88,63]];
      points.forEach(([x,y], i) => {
        const star = document.createElement('span');
        star.className = `ggx-magic-plane ggx-magic-spark ggx-magic-spark-${kind}`;
        star.setAttribute('aria-hidden', 'true');
        star.style.left = `${x}%`; star.style.top = `${y}%`;
        star.style.width = star.style.height = `${i % 3 === 0 ? 12 : 7}px`;
        const dx = kind === 'portal' ? (x - 50) * .7 : kind === 'dawn' ? 45 : kind === 'spectral' ? (50 - x) * .35 : (i % 2 ? 12 : -12);
        const dy = kind === 'portal' ? (y - 42) * .7 : kind === 'spectral' ? (42 - y) * .35 : -22;
        media.append(star); this.layers.add(star);
        this.play(star, [
          { opacity: 0, transform: 'translate(0, 0) scale(.25) rotate(0deg)' },
          { opacity: .82, offset: .42, transform: `translate(${dx * .4}px, ${dy * .4}px) scale(1) rotate(30deg)` },
          { opacity: 0, transform: `translate(${dx}px, ${dy}px) scale(.2) rotate(65deg)` }
        ], 1350, 280 + i * 90, star);
      });
    }
    plane(media, kind, frames, duration, delay = 0) {
      const layer = document.createElement('span');
      layer.className = `ggx-magic-plane ggx-magic-${kind}`;
      layer.setAttribute('aria-hidden', 'true');
      media.append(layer); this.layers.add(layer);
      this.play(layer, frames, duration, delay, layer);
    }
    play(element, frames, duration, delay = 0, layer = null) {
      const remove = () => { layer?.remove(); if (layer) this.layers.delete(layer); };
      try {
        const animation = element.animate(frames, { duration, delay, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'none' });
        this.animations.add(animation);
        const cleanup = () => { this.animations.delete(animation); remove(); };
        animation.addEventListener('finish', cleanup, { once: true });
        animation.addEventListener('cancel', cleanup, { once: true });
      } catch { remove(); }
    }
    stop() {
      this.generation++;
      for (const animation of this.animations || []) animation.cancel();
      this.animations?.clear();
      for (const layer of this.layers || []) layer.remove();
      this.layers?.clear();
    }
    disconnectedCallback() {
      this.stop(); this.observer?.disconnect(); this.abort?.abort(); this.abort = null;
    }
  }
  customElements.define(tag, MobileWorldReveals);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ggx-mobile-portal-pulse"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'ggx-mobile-portal-pulse';
  const pulsingClass = 'ggx-mobile-portal-pulsing';
  if (!window.customElements || customElements.get(tag)) return;

  class MobilePortalPulse extends HTMLElement {
    connectedCallback() {
      if (this.abort || typeof IntersectionObserver !== 'function') return;
      this.root = this.closest('.ggx-mobile-overview');
      this.cards = Array.from(this.root?.querySelectorAll('.ggx-mobile-world-card') || []);
      if (!this.cards.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.contrast = matchMedia('(forced-colors: active)');
      this.visible = new Set();
      this.visited = new Set();
      this.pageActive = true;
      this.paused = false;
      this.welcomePending = true;
      this.welcomeCards = [];
      this.readPreference();
      this.control = this.querySelector('button');
      this.control?.addEventListener('click', () => {
        this.paused = !this.paused;
        try { sessionStorage.setItem('ggx-living-motion-paused', String(this.paused)); } catch { }
        window.dispatchEvent(new CustomEvent('ggx:motion-preference', { detail: { paused: this.paused } }));
        this.refresh();
      }, options);
      const refresh = () => this.refresh();
      for (const media of [this.mobile, this.reduced, this.contrast]) media.addEventListener('change', refresh, options);
      document.addEventListener('visibilitychange', refresh, options);
      window.addEventListener('pagehide', () => { this.pageActive = false; this.stop(); }, options);
      window.addEventListener('pageshow', () => { this.pageActive = true; this.readPreference(); this.refresh(); }, options);
      const preference = (event) => {
        if (typeof event.detail?.paused !== 'boolean') return;
        this.paused = event.detail.paused;
        this.refresh();
      };
      window.addEventListener('ggx:motion-preference', preference, options);
      document.addEventListener('ggx:motion-preference', preference, options);
      window.addEventListener('storage', (event) => {
        if (event.key === 'ggx-living-motion-paused' || event.key === null) { this.readPreference(); this.refresh(); }
      }, options);
      this.root.addEventListener('focusin', refresh, options);
      this.root.addEventListener('focusout', () => queueMicrotask(refresh), options);
      this.root.addEventListener('pointerup', refresh, { ...options, passive: true });
      this.root.addEventListener('pointercancel', refresh, { ...options, passive: true });
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= .35) this.visible.add(entry.target);
          else this.visible.delete(entry.target);
        }
        this.refresh();
      }, { threshold: [0, .35] });
      this.cards.forEach((card) => this.observer.observe(card));
      this.refresh();
    }

    readPreference() {
      try {
        const value = sessionStorage.getItem('ggx-living-motion-paused');
        this.paused = value === 'true' || value === '1';
      } catch { /* The event still works when browser storage is unavailable. */ }
    }

    allowed() {
      return Boolean(this.abort && this.isConnected && this.mobile.matches && !this.reduced.matches && !this.contrast.matches && !this.paused && this.pageActive && !document.hidden && this.visible.size && !this.cards.some((card) => card === document.activeElement && card.matches(':focus-visible')));
    }

    stop() {
      clearTimeout(this.timer);
      clearTimeout(this.finishTimer);
      this.timer = this.finishTimer = null;
      for (const card of this.welcomeCards || []) {
        card.classList.remove(pulsingClass);
        card.style.removeProperty('--ggx-pulse-duration');
        card.style.removeProperty('--ggx-pulse-scale');
      }
      this.welcomeCards = [];
      if (this.current) {
        this.current.classList.remove(pulsingClass);
        this.current.style.removeProperty('--ggx-pulse-duration');
        this.current = null;
      }
    }

    refresh() {
      if (this.paused || this.reduced.matches || this.contrast.matches || document.hidden || !this.pageActive) this.welcomePending = false;
      this.hidden = !this.mobile.matches || this.reduced.matches || this.contrast.matches;
      this.dataset.paused = String(this.paused);
      if (this.control) {
        const label = this.paused ? this.control.dataset.play : this.control.dataset.pause;
        this.control.setAttribute('aria-label', label);
        this.control.setAttribute('title', label);
      }
      if (!this.allowed()) { this.stop(); return; }
      if ((this.current && !this.visible.has(this.current)) || this.welcomeCards.some((card) => !this.visible.has(card))) this.stop();
      this.schedule(this.welcomePending ? 120 + Math.random() * 80 : 350 + Math.random() * 550);
    }

    schedule(delay) {
      if (!this.allowed() || this.timer || this.current || this.welcomeCards.length) return;
      this.timer = setTimeout(() => { this.timer = null; this.pulse(); }, delay);
    }

    pulse() {
      if (!this.allowed()) return;
      if (this.welcomePending) {
        this.welcomePending = false;
        this.welcomeCards = this.cards.filter((card) => this.visible.has(card));
        for (const card of this.welcomeCards) {
          card.style.setProperty('--ggx-pulse-duration', '1800ms');
          card.style.setProperty('--ggx-pulse-scale', '1');
          card.classList.add(pulsingClass);
        }
        this.finishTimer = setTimeout(() => {
          this.stop();
          this.schedule(650 + Math.random() * 950);
        }, 1840);
        return;
      }
      let choices = this.cards.filter((card) => this.visible.has(card) && !this.visited.has(card));
      if (!choices.length) {
        this.visited.clear();
        choices = this.cards.filter((card) => this.visible.has(card) && card !== this.last);
        if (!choices.length) choices = [...this.visible];
      }
      const card = choices[Math.floor(Math.random() * choices.length)];
      if (!card) return;
      const duration = Math.round(2500 + Math.random() * 600);
      this.current = card;
      this.last = card;
      this.visited.add(card);
      card.style.setProperty('--ggx-pulse-duration', `${duration}ms`);
      card.classList.add(pulsingClass);
      this.finishTimer = setTimeout(() => {
        this.stop();
        this.schedule(650 + Math.random() * 950);
      }, duration + 40);
    }

    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.abort = null;
      this.hidden = true;
      this.observer?.disconnect();
      this.observer = null;
      this.visible?.clear();
    }
  }
  customElements.define(tag, MobilePortalPulse);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ggx-pdp-coffee-summary"] && !Shopify.designMode) return;
  try {
    function syncCoffeeSummaryFormats(){document.querySelectorAll('[data-ggcs-kcup]').forEach(link=>{const target=document.getElementById(link.hash.slice(1));link.hidden=!target||!target.matches('[data-gg-kcup-feature]');});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',syncCoffeeSummaryFormats,{once:true});}else{syncCoffeeSummaryFormats();}
document.addEventListener('shopify:section:load',syncCoffeeSummaryFormats);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ggx-portal-sparkles"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'ggx-portal-sparkles';
  if (customElements.get(tag)) return;
  class PortalSparkles extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.scene = this.closest('ggx-portal-scene');
      this.stage = this.scene?.querySelector('.ggx-entrance-desktop .ggx-threshold') || this.scene?.querySelector('.ggx-threshold');
      if (!this.scene || !this.stage) return;
      this.abort = new AbortController();
      const options = { signal:this.abort.signal, passive:true };
      this.desktop = matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)');
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.contrast = matchMedia('(forced-colors:active)');
      this.particles = []; this.frame = 0; this.lastEmit = 0; this.localPaused = false;
      this.readPreference();
      this.canvas = document.createElement('canvas');
      this.canvas.className = 'ggx-portal-sparkle-canvas';
      this.canvas.setAttribute('aria-hidden','true');
      this.ctx = this.canvas.getContext('2d');
      const refresh = () => { this.reset(); this.stage.classList.toggle('ggx-wand-ready', this.allowed() && this.desktop.matches); };
      this.stage.addEventListener('pointermove', event => {
        if (!this.allowed() || !this.desktop.matches || event.pointerType !== 'mouse') return;
        const now = performance.now();
        if (now - this.lastEmit < 28) return;
        this.lastEmit = now;
        this.prepare(this.stage.getBoundingClientRect());
        this.emit(event.clientX-this.rect.left,event.clientY-this.rect.top,2,false,now);
      }, options);
      this.stage.addEventListener('pointerleave', () => this.reset(), options);
      this.stage.addEventListener('pointercancel', () => this.reset(), options);
      this.scene.addEventListener('pointerdown', event => {
        this.touch = null;
        if (event.pointerType !== 'touch' || !event.isPrimary || !this.mobile.matches || !this.allowed()) return;
        const card = event.target.closest('.ggx-mobile-world-card');
        if (card && this.scene.contains(card)) this.touch = {id:event.pointerId,x:event.clientX,y:event.clientY,card,time:performance.now()};
      }, options);
      this.scene.addEventListener('pointermove', event => {
        if (this.touch?.id === event.pointerId && Math.hypot(event.clientX-this.touch.x,event.clientY-this.touch.y)>10) this.touch=null;
      }, options);
      this.scene.addEventListener('pointercancel', () => { this.touch=null; }, options);
      this.scene.addEventListener('pointerup', event => {
        const touch = this.touch; this.touch=null;
        if (!touch || touch.id!==event.pointerId || !this.allowed() || !this.mobile.matches || performance.now()-touch.time>700 || Math.hypot(event.clientX-touch.x,event.clientY-touch.y)>10) return;
        const box=touch.card.getBoundingClientRect();
        if (event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom) return;
        // Paint immediately; native link navigation is never cancelled or delayed.
        this.reset();
        this.prepare({left:Math.max(0,event.clientX-80),top:Math.max(0,event.clientY-80),width:160,height:160});
        this.emit(event.clientX-this.rect.left,event.clientY-this.rect.top,18,true,performance.now());
        this.draw(performance.now());
      }, options);
      const preference = event => { if(typeof event.detail?.paused==='boolean') { this.paused=event.detail.paused; refresh(); } };
      window.addEventListener('ggx:motion-preference',preference,options);
      document.addEventListener('ggx:motion-preference',preference,options);
      window.addEventListener('storage',event=>{if(event.key==='ggx-living-motion-paused'||event.key===null){this.readPreference();refresh();}},options);
      this.scene.querySelector('[data-portal-choice="still"]')?.addEventListener('click',()=>{this.localPaused=true;refresh();},options);
      this.scene.querySelector('[data-portal-choice="motion"]')?.addEventListener('click',()=>{this.localPaused=false;refresh();},options);
      for (const media of [this.desktop,this.mobile,this.reduced,this.contrast]) media.addEventListener('change',refresh,options);
      document.addEventListener('visibilitychange',refresh,options);
      window.addEventListener('pagehide',()=>this.reset(),options);
      window.addEventListener('pageshow',refresh,options);
      window.addEventListener('blur',()=>this.reset(),options);
      window.addEventListener('resize',()=>this.reset(),options);
      window.addEventListener('scroll',()=>{this.touch=null;this.reset();},{...options,capture:true});
      refresh();
    }
    readPreference(){try{this.paused=['true','1'].includes(sessionStorage.getItem('ggx-living-motion-paused'));}catch{this.paused=false;}}
    allowed(){return this.isConnected && this.ctx && !document.hidden && !this.paused && !this.localPaused && !this.reduced.matches && !this.contrast.matches;}
    prepare(rect){
      if(this.rect)return;
      this.rect=rect;
      const dpr=Math.min(devicePixelRatio||1,1.5);
      this.canvas.width=Math.ceil(rect.width*dpr);this.canvas.height=Math.ceil(rect.height*dpr);
      Object.assign(this.canvas.style,{left:rect.left+'px',top:rect.top+'px',width:rect.width+'px',height:rect.height+'px'});
      this.ctx.setTransform(dpr,0,0,dpr,0,0);
      this.scene.append(this.canvas);
    }
    emit(x,y,count,burst,now){
      for(let i=0;i<count;i++){
        const angle=Math.random()*Math.PI*2,speed=burst?25+Math.random()*60:3+Math.random()*7;
        this.particles.push({x,y,born:now,burst,life:burst?380+Math.random()*100:1000+Math.random()*450,vx:Math.cos(angle)*speed,vy:Math.sin(angle)*speed,size:burst?1+Math.random()*2.1:.7+Math.random()*1.25,color:i%3?'#f1d6a1':'#c7f5ff'});
      }
      if(this.particles.length>96)this.particles.splice(0,this.particles.length-96);
      if(!this.frame)this.frame=requestAnimationFrame(now=>this.tick(now));
    }
    draw(now){
      if(!this.rect)return;
      const ctx=this.ctx;ctx.clearRect(0,0,this.rect.width,this.rect.height);
      this.particles=this.particles.filter(p=>now-p.born<p.life);
      for(const p of this.particles){
        const age=now-p.born,t=age/1000,fade=1-age/p.life;
        const x=p.x+p.vx*t,y=p.y+p.vy*t+(p.burst?12:3)*t*t,s=p.size*(.5+fade*.5);
        ctx.globalAlpha=fade*.9;ctx.fillStyle=p.color;
        if(p.burst){
          ctx.beginPath();ctx.moveTo(x,y-s*2);ctx.lineTo(x+s*.45,y-s*.45);ctx.lineTo(x+s*2,y);ctx.lineTo(x+s*.45,y+s*.45);ctx.lineTo(x,y+s*2);ctx.lineTo(x-s*.45,y+s*.45);ctx.lineTo(x-s*2,y);ctx.lineTo(x-s*.45,y-s*.45);ctx.closePath();ctx.fill();
        }else{
          // Soft dust motes linger behind the tip, without star points or a blur filter.
          ctx.globalAlpha=fade*.12;ctx.beginPath();ctx.arc(x,y,s*3,0,Math.PI*2);ctx.fill();
          ctx.globalAlpha=fade*.28;ctx.beginPath();ctx.arc(x,y,s*1.8,0,Math.PI*2);ctx.fill();
          ctx.globalAlpha=fade*.85;ctx.beginPath();ctx.arc(x,y,s*.7,0,Math.PI*2);ctx.fill();
        }
      }
      ctx.globalAlpha=1;
    }
    tick(now){this.frame=0;if(!this.allowed()){this.reset();return;}this.draw(now);if(this.particles.length)this.frame=requestAnimationFrame(time=>this.tick(time));else this.reset();}
    reset(){cancelAnimationFrame(this.frame);this.frame=0;this.particles=[];this.rect=null;this.canvas?.remove();}
    disconnectedCallback(){this.reset();this.stage?.classList.remove('ggx-wand-ready');this.abort?.abort();this.abort=null;}
  }
  customElements.define(tag,PortalSparkles);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ggx-shipping-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ggx-shipping-promo')) {
    customElements.define('ggx-shipping-promo', class extends HTMLElement {
      connectedCallback() {
        if (this.copyButton) return;
        this.copyButton = this.querySelector('.ggx-shipping-promo__copy');
        this.code = this.querySelector('.ggx-shipping-promo__code');
        this.status = this.querySelector('.ggx-shipping-promo__status');
        if (!this.copyButton || !this.code || !this.status) return;
        this.onCopy = async () => {
          clearTimeout(this.resetTimer);
          this.status.textContent = '';
          try {
            if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(this.code.value);
            this.copyButton.textContent = this.dataset.copied;
            this.status.textContent = this.dataset.success;
            this.resetTimer = setTimeout(() => { this.copyButton.textContent = this.dataset.copy; }, 3000);
          } catch {
            this.copyButton.textContent = this.dataset.copy;
            this.status.textContent = this.dataset.fallback;
            this.code.focus();
            this.code.select();
          }
        };
        this.copyButton.addEventListener('click', this.onCopy);
        this.copyButton.hidden = false;
      }
      disconnectedCallback() {
        clearTimeout(this.resetTimer);
        this.copyButton?.removeEventListener('click', this.onCopy);
        this.copyButton = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ggx-warehouse-card-facts"] && !Shopify.designMode) return;
  try {
    (() => {
  const fields = ['.ggx-product-title', '.ggx-card-facts__roast', '.ggx-card-facts__kind', '.ggx-card-facts__notes'];
  const initialize = () => {
    document.querySelectorAll('.ggx-warehouse .ggx-product-grid').forEach((grid) => {
      if (grid.dataset.ggxFactsAligned || !grid.querySelector('[data-ggx-card-facts]')) return;
      grid.dataset.ggxFactsAligned = 'true';
      let frame = 0;
      let width = 0;
      const align = () => {
        frame = 0;
        const cards = [...grid.querySelectorAll('.ggx-product-card')].filter((card) => card.querySelector('[data-ggx-card-facts]'));
        cards.forEach((card) => fields.forEach((selector) => { card.querySelector(selector).style.minBlockSize = ''; }));
        const rows = new Map();
        cards.filter((card) => card.getClientRects().length).forEach((card) => {
          const top = Math.round(card.getBoundingClientRect().top);
          if (!rows.has(top)) rows.set(top, []);
          rows.get(top).push(card);
        });
        rows.forEach((row) => fields.forEach((selector) => {
          const height = Math.max(...row.map((card) => card.querySelector(selector).getBoundingClientRect().height));
          row.forEach((card) => { card.querySelector(selector).style.minBlockSize = `${height}px`; });
        }));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
      new ResizeObserver((entries) => {
        const next = entries[0].contentRect.width;
        if (next !== width) { width = next; schedule(); }
      }).observe(grid);
      new MutationObserver(schedule).observe(grid, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
      document.fonts.ready.then(schedule);
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
